<div class="page-title">
  <h2 *ngIf="!role">Création de rôle</h2>
  <h2 *ngIf="role">Modification de rôle</h2>
</div>

<div class="page-content">
  <div class="profile-name-wrapper" *ngIf="formGroup">
    <frg-form-input label="Nom du rôle" type="text" [formGroup]="formGroup" [control]="formGroup.get('name')"
      errorMessage="{{ inputProfileNameErrorMsg }}" required="true">
    </frg-form-input>
    <frg-form-input  label="Possède un espace personnel ?" id="espacePerso" type="checkbox"
    [formGroup]="formGroup" [control]="formGroup.get('espacePerso')" [isCheckLabelAlign]="true">
    </frg-form-input>
    <frg-form-input  label="Accès aux données médicales" id="espacePerso" type="checkbox"
    [formGroup]="formGroup" [control]="formGroup.get('donneesMedicales')" [isCheckLabelAlign]="true">
    </frg-form-input>
    <div class="disabled" *ngIf="role && role.disabled">
      <p>Ce rôle est désactivé, voulez-vous le réactiver ?</p>
      <frg-button (activated)="reactive(role)" [backgroundColor]="'var(--primary)'"> Réactiver le rôle</frg-button>
    </div>
  </div>

  <div class="domains-table">
    <frg-table-radio-button [headerLabel]="keysHeaderLabel" [headerValues]="keysHeaderValue" [bodyValues]="domainsList">
    </frg-table-radio-button>
  </div>
  <div class="button-wrapper">
    <frg-button (activated)="doSaveRole()" [backgroundColor]="'var(--primary)'">Sauvegarder</frg-button>
  </div>
</div>
